export default {
  path: '/trss',
  component: () => import('@/components/pages/TRSs/TRSs')
}
